export const fontSizes = {
  '2xs': '0.625rem',
};
